import React, { Component } from 'react';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';

import Parse from 'parse';

class ForgotPasswordDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: null,
    };
  }

  handleReset = () => {
    const that = this;

    Parse.User.requestPasswordReset(this.state.email, {
      success: function() {
        // Password reset request was sent successfully
        that.props.onResetSuccess();
      },
      error: function(error) {
        // Show the error message somewhere
        alert("Error: " + error.code + " " + error.message);
      }
    });
  }

  render() {
    const actions = [
      <FlatButton
        label='Cancel'
        primary={true}
        onClick={this.props.onClose} />,
      <FlatButton
        label="Reset"
        primary={true}
        onClick={this.handleReset} />
    ];

    return (
      <Dialog
        open={this.props.open}
        onRequestClose={this.props.onCancel}
        actions={actions}
        title='Forgot your password?'
        contentStyle={{width: '40%'}}>

        Enter your account email address and we'll send instructions for resetting your password.

        <TextField
          style={{width: '100%'}}
          hintText="Email"
          floatingLabelText="Email"
          onChange={(event, newValue) => this.setState({email: newValue})}
        />
        
      </Dialog>
    );
  }
}

export default ForgotPasswordDialog;


// WEBPACK FOOTER //
// ./src/scenes/Authentication/components/ForgotPasswordDialog.js